module.exports = __webpack_public_path__ + "static/media/restaurants.95be72f2.jpg";